function Blog() {
  return <section className="bg-gradient-to-b from-blue-900 to-black text-white min-h-[90vh] flex items-center justify-center w-full">
    <h1 className="text-5xl">Blogs Coming Soon!</h1>
  </section>;
}

export default Blog;
